<template>
  <div class="homeHeaderTitle">
    <div class="box">
      <div class="title">{{model.title}}</div>
      <div class="img-line-box">
        <div class="img-box" v-for="(item, i) in model.itemList" :key="i" v-show="getShow(i)">
          <img :src="getUpImage(item.selectUp)" @click="clickUp(i)">
          <img :src="getDownImage(item.selectDown)" @click="clickDown(i)" class="img">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "homeHeaderTitle",
  props: {
    model: {
      type: Object,
      default: () => {}
    },
    isShowThree: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      
    };
  },
  methods: {
    getShow(i) {
      if (i >= 1) {
        return this.isShowThree
      }
      return true;
    },
    getUpImage(isSelect) {
      return isSelect ? require("@/assets/icon-select-up.png") : require("@/assets/icon-up.png")
    },
    getDownImage(isSelect) {
      return isSelect ? require("@/assets/icon-select-down.png") : require("@/assets/icon-down.png")
    },
    clickUp(ind) {
      this.$emit("clickSort", {isUp: true, titleIndex: this.index, iconIndex: ind})
    },

    clickDown(ind) {
      this.$emit("clickSort", {isUp: false, titleIndex: this.index, iconIndex: ind})
    }
  },
  created() {},
};
</script>
<style lang='less' scoped>
.box {
  width: 150px;
  height: 50px;
  border-radius: 6px;
  background-color: #fff;
}

.title {
  height: 100%;
  width: 100%;
  color: #707070;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  word-wrap: break-word;
  word-break: break-word;
}

.img-line-box {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 10px;
}

.img-box {
  display: flex;
  flex-direction: row;

  img {
    margin-left: 2px;
    width: 12px;
    height: 12px;
    object-fit: contain;
  }
}
</style>